import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AcoesEmmiter, Contrato } from '../../../base/vo/contrato';

@Component({
  selector: 'app-admin-contratos-acoes',
  templateUrl: './admin-contratos-acoes.component.html',
  styleUrls: ['./admin-contratos-acoes.component.scss'],
})
export class AdminContratosAcoesComponent implements OnInit {
  @Input() contrato: Contrato;

  @Output() acoesEmmitter: EventEmitter<AcoesEmmiter> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  public onClick(
    action: number,
    acao: string,
    contratoId: number,
    contratoTitle?: string
  ) {
    if (this.contrato.acoes[acao]) {
      this.acoesEmmitter.emit({ action, contratoId, contratoTitle });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/contratos/admin-contratos-acoes/admin-contratos-acoes.component.ts